import React from "react";
import { IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader, Button as MuiButton, Tooltip } from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { observer } from "mobx-react-lite";
import PeopleIcon from "@material-ui/icons/People";
import CloseIcon from "@material-ui/icons/Close";
import EventLabel from "../../components/EventLabel";
const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}))(Badge);

export const FloatingGroupOrderCart = observer(({ orders, setActiveOrder, removeOrder, activePersonNo, setLeader }) => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          left: 10,
          bottom: 10,
          zIndex: 120,
          display: orders.length < 2 ? "none" : "initial",
        }}
      >
        <IconButton style={{ backgroundColor: "#fff" }} className="floating-cart-btn" onClick={handleClickOpen}>
          <StyledBadge badgeContent={orders.length || 1} color="error">
            <PeopleIcon />
          </StyledBadge>
        </IconButton>
      </div>
      {open ? (
        <div className="backdrop">
          <div className={"aside-list" + (open ? " show" : " hidden")} style={{ display: "flex" }}>
            <div>
              <IconButton style={{ padding: 0, margin: "15px 0px 0px 7px" }} onClick={handleClose}>
                <CloseIcon />
              </IconButton>{" "}
            </div>
            <div>
              <DialogTitle id="responsive-dialog-title" style={{ padding: "10px 16px 0px 16px" }}>
                <EventLabel name={"MyOrders"} groupName={"Cms.GroupModule"} />

              </DialogTitle>
              <DialogContent style={{ padding: "0px 15px" }} className="jir-dialog-content">
                <DialogContentText>
                  <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                      <ListSubheader component="div" style={{ padding: 0 }} id="nested-list-subheader">
                        <EventLabel name={"EditOrDeletePersons"} groupName={"Cms.GroupModule"} />

                      </ListSubheader>
                    }
                  >
                    {orders.map((o, i) => {
                      return (
                        <ListItem key={i} style={{ paddingLeft: 0 }}>
                          <ListItemIcon>
                            <AccountCircleIcon className={i == activePersonNo ? "cms-active" : ""} />
                          </ListItemIcon>
                          <ListItemText primary={o.person ? (o?.person?.firstName ?? "") + " " + (o?.person?.lastName ?? "") : <EventLabel name={"PersonNameIsNotFilledWarn"} groupName={"Cms.GroupModule"} />} />
                          <ListItemSecondaryAction>
                            <IconButton
                              onClick={() => {
                                setActiveOrder(i);
                                handleClose();
                              }}
                            >
                              <Tooltip title={<EventLabel name={"EditPersonTooltip"} groupName={"Cms.GroupModule"} />}>
                                <CreateIcon />
                              </Tooltip>
                            </IconButton>

                            {orders.length > 1 ? (
                              <IconButton
                                style={{ opacity: o.leader == true || (o.orderId == o.orderGroupId && orders.filter((o) => o.leader == true).length == 0) ? 1 : 0.5 }}
                                onClick={() => {
                                  orders[i].invoice=orders.filter(a => a.leader)[0].invoice;
                                  orders[i].orderExtra=orders.filter(a => a.leader)[0].orderExtra;
                                  setLeader(i);
                                  orders.filter(a => !a.leader).map(x => x.invoice = {});
                                  orders.filter(a => !a.leader).map(x => x.orderExtra = []);

                                }}
                              >
                                <Tooltip title={o.leader == true ? <EventLabel name={"CurrentGroupLeaderTooltip"} groupName={"Cms.GroupModule"} />: <EventLabel name={"MakeGroupLeaderTooltip"} groupName={"Cms.GroupModule"} />}>
                                  <VerifiedUserIcon />
                                </Tooltip>
                              </IconButton>
                            ) : null}
                            {!o.orderId ? (
                              <Tooltip title={o.leader == true ? <EventLabel name={"DeleteLeaderTooltipWarn"} groupName={"Cms.GroupModule"} /> : <EventLabel name={"DeletePersonTooltip"} groupName={"Cms.GroupModule"} />}>
                                <span>
                                  <IconButton disabled={orders.length == 1 || o.leader == true} onClick={() => removeOrder(i)}>
                                    <DeleteIcon />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            ) : null}
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>
                </DialogContentText>
              </DialogContent>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
});
